import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { ChartDoughnut, FooterReport, Gap, LabelTitle, Line, ProgressBar } from "../../../components/Global";

const ReportPeminatan = (props) => {
    const [detail, SetDetail] = useState([]);
    const [detailNon, SetDetailNon] = useState([]);
    const [listMapel, SetListMapel] = useState([]);
    const [placeIpa, SetPlaceIpa] = useState([]);
    const [placeIps, SetPlaceIps] = useState([]);
    const [placeBhs, SetPlaceBhs] = useState([]);
    const [placeAgama, SetPlaceAgama] = useState([]);
    const [blmSelesai, SetBlmSelesai] = useState([]);

    const today = new Date();
    const suflix = today.getHours() >= 12 ? " PM" : " AM";
    const dateTime = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + ", " + today.getHours() + "." + today.getMinutes() + suflix;

    useEffect(() => {
        const responseData = props.response.data.data;
        console.log('response data, ', props)

        SetDetail(responseData.detail);
        SetDetailNon(responseData.detailNon);
        SetListMapel(responseData.listMapel);
        SetPlaceIpa(responseData.placeIpa);
        SetPlaceIps(responseData.placeIps);
        SetPlaceBhs(responseData.placeBhs);
        SetPlaceAgama(responseData.placeAgama);
        SetBlmSelesai(responseData.blmSelesai);

        document.title = "Report Peminatan - " + responseData.detail.namaSekolah;
    }, []);

    const renderSkorMapelSiswa = (arr, siswa) => {
        return arr.map((mp, m) =>
            siswa.listSkor.map((skor, sw) => {
                if (mp.namaMapelSingkatan === skor.namaMataPelajaran) {
                    return <td>{skor.skor}</td>;
                }
                if (skor.namaMataPelajaran === null) {
                    return <td>-</td>;
                }
            })
        );
    };

    require("./ReportPeminatan.css");
    return (
        <div>
            <div className="report-page">
                <img src="/assets/image/cover-peminatan.svg" width={"100%"} />
            </div>
            {/* page 1 */}
            <div className="report-page">
                <div className="cardLine">
                    <div className="pnl-header">
                        <div className="card-page">
                            <span style={{
                                fontSize: '26px',
                                color: '#FFF',
                                fontWeight: 500,
                                fontFamily: 'lucida grande'
                            }}>01</span>
                        </div>
                        <div className="pnl-date">
                            Jadwal Asesmen {detail.tglUjian}
                        </div>
                    </div>
                    <div className="header-first-page" style={{ padding: '0px' }}>
                        <div className="text-header" style={{ padding: '0px' }}>
                            <div className="title-header2" style={{ color: '#015E56' }}>REPORT SEKOLAH</div>
                            <div className="label-sub-tit">
                                <span className="sub-title-header" style={{ color: '#FFF' }}>Program Peminatan</span>
                            </div>
                        </div>
                        <div className="image-header">
                            <div className="logo-edu">
                                <img src="https://eduprime.co.id/static/images/LOGO_EDUPRIME_2.png" width={"100%"} />
                            </div>
                            <div className="logo-an">
                                <img src="/assets/image/LOGO_PEMINATAN_1.png" width={"100%"} />
                            </div>
                        </div>
                    </div>
                    <div className="pnl-profile" style={{ marginTop: '5%', marginBottom: '0px' }}>
                        <div className="card-profile">
                            <div>
                                <img src="/assets/image/icon-sekolah.svg" width="60px" alt="" />
                            </div>
                            <div>
                                <span className="label-profile-name">Nama Sekolah</span>
                                <p className="label-value-profil">{detail.namaSekolah}</p>
                            </div>
                        </div>
                        <div className="card-profile">
                            <div>
                                <img src="/assets/image/icon-person.svg" width="60px" alt="" />
                            </div>
                            <div>
                                <span className="label-profile-name">Jumlah Siswa</span>
                                <p className="label-value-profil">{detail.jumlahSiswa}</p>
                            </div>
                        </div>
                        <div className="card-profile">
                            <div>
                                <img src="/assets/image/mdi_time.svg" width="60px" alt="" />
                            </div>
                            <div>
                                <span className="label-profile-name">Jadwal Asesmen</span>
                                <p className="label-value-profil">{detail.tglUjian}</p>
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', gap: '20px', justifyContent: 'space-between' }}>
                        <div className="card-profile">
                            <div style={{ width: '100%', marginBottom: '20px' }}>
                                <span className="label-profile-name">Placement</span>
                                <div style={{ width: '100%', display: 'flex' }}>
                                    <LabelTitle label={"* "} size={14} bolder={300} color={"#EB5757"} />
                                    <LabelTitle label={"Berdasarkan test dan kuota"} size={14} bolder={300} color={"#6C757D"} />
                                </div>
                            </div>
                            <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div style={{ width: '100%', display: "flex", justifyContent: 'center', marginBottom: '20px' }}>
                                    <div style={{ display: 'flex', gap: '20px' }}>
                                        <div style={{ display: "flex", gap: '10px', }}>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <div style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#02A76B' }}></div>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <span style={{ fontSize: '18px', fontWeight: '500' }}>{detail.jumPlaceIpa} Siswa</span>
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", gap: '10px', }}>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <div style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#BEF264' }}></div>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <span style={{ fontSize: '18px', fontWeight: '500' }}>{detail.jumPlaceIps} Siswa</span>
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", gap: '10px', }}>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <div style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#97F9AE' }}></div>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <span style={{ fontSize: '18px', fontWeight: '500' }}>{detail.jumPlaceBhs} Siswa</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <ChartDoughnut valueChart={[detail.percentPlaceIpa, detail.percentPlaceIps, detail.percentPlaceBhs]} chartColor={["#02A76B", "#BEF264", "#97F9AE"]} chartLabel={["IPA", "IPS", "Bahasa"]} />
                            </div>

                        </div>
                        <div className="card-profile">
                            <div style={{ width: '100%', marginBottom: '20px' }}>
                                <span className="label-profile-name">Recommendation</span>
                                <div style={{ width: '100%', display: 'flex' }}>
                                    <LabelTitle label={"* "} size={14} bolder={300} color={"#EB5757"} />
                                    <LabelTitle label={"Berdasarkan hasil test siswa"} size={14} bolder={300} color={"#6C757D"} />
                                </div>
                            </div>
                            <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div style={{ width: '100%', display: "flex", justifyContent: 'center', marginBottom: '20px' }}>
                                    <div style={{ display: 'flex', gap: '20px' }}>
                                        <div style={{ display: "flex", gap: '10px', }}>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <div style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#02A76B' }}></div>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <span style={{ fontSize: '18px', fontWeight: '500' }}>{detail.recomIpa} Siswa</span>
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", gap: '10px', }}>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <div style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#BEF264' }}></div>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <span style={{ fontSize: '18px', fontWeight: '500' }}>{detail.recomIps} Siswa</span>
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", gap: '10px', }}>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <div style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#97F9AE' }}></div>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <span style={{ fontSize: '18px', fontWeight: '500' }}>{detail.recomBhs} Siswa</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <ChartDoughnut valueChart={[detail.percentRecomIpa, detail.percentRecomIps, detail.percentRecomBhs]} chartColor={["#02A76B", "#BEF264", "#97F9AE"]} chartLabel={["IPA", "IPS", "Bahasa"]} />
                            </div>
                        </div>
                    </div>
                    <div className="card-profile">
                        <LabelTitle label={"Learning Style"} size={25} bolder={700} color={"#212529"} />
                        <Gap height={5} />
                        <div style={{ width: '100%', display: 'flex', gap: '20px' }}>
                            <div className="card-learnStyle">
                                <div>
                                    <img src="/assets/image/mdi_eye.svg" width="60px" alt="" />
                                </div>
                                <div className="label-persen-learnStyle">
                                    <span style={{ fontSize: '18px', fontWeight: '600', color: '#FFF' }}>{detailNon.percenVisual} %</span>
                                </div>
                                <div style={{ textAlign: 'center' }}>
                                    <span style={{ fontSize: '28px', fontWeight: '700', color: '#015E56' }}>Visual</span>
                                    <p style={{ fontSize: '16px', fontWeight: '400', color: '#015E56' }}>{detailNon.jumVisual} Siswa</p>
                                </div>
                            </div>
                            <div className="card-learnStyle">
                                <div>
                                    <img src="/assets/image/mdi_ear.svg" width="60px" alt="" />
                                </div>
                                <div className="label-persen-learnStyle">
                                    <span style={{ fontSize: '18px', fontWeight: '600', color: '#FFF' }}>{detailNon.percenAuditori} %</span>
                                </div>
                                <div style={{ textAlign: 'center' }}>
                                    <span style={{ fontSize: '28px', fontWeight: '700', color: '#015E56' }}>Auditori</span>
                                    <p style={{ fontSize: '16px', fontWeight: '400', color: '#015E56' }}>{detailNon.jumAuditori} Siswa</p>
                                </div>
                            </div>
                            <div className="card-learnStyle">
                                <div>
                                    <img src="/assets/image/mdi_stop.svg" width="60px" alt="" />
                                </div>
                                <div className="label-persen-learnStyle">
                                    <span style={{ fontSize: '18px', fontWeight: '600', color: '#FFF' }}>{detailNon.percenKinestetik} %</span>
                                </div>
                                <div style={{ textAlign: 'center' }}>
                                    <span style={{ fontSize: '28px', fontWeight: '700', color: '#015E56' }}>Kinestetik</span>
                                    <p style={{ fontSize: '16px', fontWeight: '400', color: '#015E56' }}>{detailNon.jumKinestetik} Siswa</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="reportFooter">
                    <FooterReport date={dateTime} />
                </div> */}
            </div>
            {/* page 2 */}
            <div className="report-page">
                <div className="cardLine">
                    <div className="pnl-header">
                        <div className="card-page">
                            <span style={{
                                fontSize: '26px',
                                color: '#FFF',
                                fontWeight: 500,
                                fontFamily: 'lucida grande'
                            }}>02</span>
                        </div>
                        <div className="pnl-date">
                            Jadwal Asesmen {detail.tglUjian}
                        </div>
                    </div>
                    <div className="header-first-page" style={{ padding: '0px' }}>
                        <div className="text-header" style={{ padding: '0px' }}>
                            <div className="title-header2" style={{ color: '#015E56' }}>REPORT SEKOLAH</div>
                            <div className="label-sub-tit">
                                <span className="sub-title-header" style={{ color: '#FFF' }}>Program Peminatan</span>
                            </div>
                        </div>
                        <div className="image-header">
                            <div className="logo-edu">
                                <img src="https://eduprime.co.id/static/images/LOGO_EDUPRIME_2.png" width={"100%"} />
                            </div>
                            <div className="logo-an">
                                <img src="/assets/image/LOGO_PEMINATAN_1.png" width={"100%"} />
                            </div>
                        </div>
                    </div>
                    <div className="card-profile" style={{ marginTop: '5%' }}>
                        <LabelTitle label={"Rata - Rata Kognitif"} size={25} bolder={700} color={"#212529"} />
                        <div className="flex-kognitf">
                            {listMapel.map((dataMapel, i) => {
                                return (
                                    <div key={i} className="section-three-left">
                                        <div>
                                            <div className="section-three-progress-bar">
                                                <ProgressBar level={dataMapel.namaMapel} progressValue={dataMapel.rataMapel} progressColor={"#02A76B"} heightBar={20} />
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div style={{ width: '100%', display: 'flex', gap: '20px' }}>
                        <div className="card-profile" style={{ width: '31%' }}>
                            <div style={{ textAlign: "left" }}>
                                <LabelTitle label={"Adversity Quotient"} size={22} bolder={700} color={"#495057"} />
                                <LabelTitle label={"(Daya Juang)"} size={16} bolder={400} color={"#6C757D"} />
                            </div>
                            <Gap height={15} />
                            <ChartDoughnut valueChart={[detailNon.jumAqBawah, detailNon.jumAqTengah, detailNon.jumAqAtas]} chartColor={["#02A76B", "#BEF264", "#97F9AE"]} chartLabel={["IPA", "IPS", "Bahasa"]} legend={true} />
                        </div>
                        <div className="card-profile" style={{ width: '31%' }}>
                            <div style={{ textAlign: "left" }}>
                                <LabelTitle label={"Achievement Motivation"} size={22} bolder={700} color={"#495057"} />
                                <LabelTitle label={"(Motivasi Berprestasi)"} size={16} bolder={400} color={"#6C757D"} />
                            </div>
                            <Gap height={15} />
                            <ChartDoughnut valueChart={[detailNon.jumEqBawah, detailNon.jumEqTengah, detailNon.jumEqAtas]} chartColor={["#02A76B", "#BEF264", "#97F9AE"]} chartLabel={["IPA", "IPS", "Bahasa"]} legend={true} />
                        </div>
                        <div className="card-profile" style={{ width: '31%' }}>
                            <div style={{ textAlign: "left" }}>
                                <LabelTitle label={"Emotional Quotient"} size={22} bolder={700} color={"#495057"} />
                                <LabelTitle label={"(Kecerdasan Emosi)"} size={16} bolder={400} color={"#6C757D"} />
                            </div>
                            <Gap height={15} />
                            <ChartDoughnut valueChart={[detailNon.jumAmBawah, detailNon.jumAmTengah, detailNon.jumAmAtas]} chartColor={["#02A76B", "#BEF264", "#97F9AE"]} chartLabel={["IPA", "IPS", "Bahasa"]} legend={true} />
                        </div>
                    </div>


                </div>

            </div>

            {/* page 3 */}
            {placeIpa.length > 0 && (
                <>
                    <div className="report-page">
                        <div className="cardLine">
                            <div className="pnl-header">
                                <div className="card-page">
                                    <span style={{
                                        fontSize: '26px',
                                        color: '#FFF',
                                        fontWeight: 500,
                                        fontFamily: 'lucida grande'
                                    }}>03</span>
                                </div>
                                <div className="pnl-date">
                                    Jadwal Asesmen {detail.tglUjian}
                                </div>
                            </div>
                            <div className="header-first-page" style={{ padding: '0px' }}>
                                <div className="text-header" style={{ padding: '0px' }}>
                                    <div className="title-header2" style={{ color: '#015E56' }}>Hasil Program Peminatan Sekolah</div>
                                    <div className="label-sub-tit">
                                        <span className="sub-title-header" style={{ color: '#FFF' }}>Program Peminatan</span>
                                    </div>
                                </div>
                                <div className="image-header">
                                    <div className="logo-edu">
                                        <img src="https://eduprime.co.id/static/images/LOGO_EDUPRIME_2.png" width={"100%"} />
                                    </div>
                                    <div className="logo-an">
                                        <img src="/assets/image/LOGO_PEMINATAN_1.png" width={"100%"} />
                                    </div>
                                </div>
                            </div>

                            <div style={{ width: '100%', display: 'flex', gap: '20px', marginTop: '5%' }}>
                                <div style={{ width: '6%' }}>
                                    <img src="/assets/image/la_atom.svg" width={"60px"} />
                                </div>
                                <div style={{ width: '94%' }}>
                                    <span style={{ fontSize: '28px', fontWeight: '700', color: '#212121' }}>Placement IPA</span>
                                    <div style={{ display: 'flex', gap: '20px' }}>
                                        <div style={{ display: 'flex', gap: '20px' }}>
                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <img src="/assets/image/mdi_check1_red.svg" width={"20px"} />
                                                <span style={{ fontSize: '18px', fontWeight: '400', color: '#6C757D' }}>Dibawah Rata-Rata</span>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', gap: '20px' }}>
                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <img src="/assets/image/mdi_doubleCheck_blue.svg" width={"20px"} />
                                                <span style={{ fontSize: '18px', fontWeight: '400', color: '#6C757D' }}>Rata-Rata</span>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', gap: '20px' }}>
                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <img src="/assets/image/verified_light_green.svg" width={"20px"} />
                                                <span style={{ fontSize: '18px', fontWeight: '400', color: '#6C757D' }}>Diatas Rata-Rata</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginTop: '3%' }}>
                                <table width={"100%"}>
                                    <thead
                                        style={{
                                            backgroundColor: "#BEF264",
                                            color: "#015E56",
                                            textAlign: "center",
                                        }}
                                    >
                                        <tr>
                                            <td rowSpan={2} width={"5%"}>
                                                No
                                            </td>
                                            <td rowSpan={2} width={"25%"}>
                                                Nama Siswa
                                            </td>
                                            <td colSpan={8} width={"25%"}>
                                                Mata Pelajaran
                                            </td>
                                            <td rowSpan={2} width={"10%"}>
                                                Rekomendasi
                                            </td>
                                            <td rowSpan={2} width={"10%"}>
                                                Placement
                                            </td>
                                            <td rowSpan={2} width={"10%"}>
                                                Learning Style
                                            </td>
                                            <td rowSpan={2} width={"5%"}>
                                                AQ
                                            </td>
                                            <td rowSpan={2} width={"5%"}>
                                                EQ
                                            </td>
                                            <td rowSpan={2} width={"5%"}>
                                                AM
                                            </td>
                                        </tr>
                                        <tr style={{ fontWeight: 100 }}>
                                            {listMapel.map((dataMapel, i) => {
                                                return <td key={i}>{dataMapel.namaMapelSingkatan}</td>;
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody
                                        style={{
                                            color: "#6C757D",
                                            textAlign: "center",
                                        }}
                                    >
                                        {placeIpa.length > 0 &&
                                            placeIpa.map((sk, i) => (
                                                <tr
                                                    style={{
                                                        borderBottom: "1px solid #E9ECEF",
                                                    }}
                                                >
                                                    <td>{i + 1}</td>
                                                    <td
                                                        style={{
                                                            textAlign: "left",
                                                        }}
                                                    >
                                                        {sk.namaSiswa}
                                                    </td>
                                                    {renderSkorMapelSiswa(listMapel, sk)}
                                                    <td>{sk.result}</td>
                                                    <td>{sk.placement}</td>
                                                    <td>{sk.resultLs}</td>
                                                    <td>{sk.resultAq != null ? <img src={"/assets/image/" + sk.resultAq + ".svg"} width={"45%"} /> : "-"}</td>
                                                    <td>{sk.resultEq != null ? <img src={"/assets/image/" + sk.resultEq + ".svg"} width={"45%"} /> : "-"}</td>
                                                    <td>{sk.resultAm != null ? <img src={"/assets/image/" + sk.resultAm + ".svg"} width={"45%"} /> : "-"}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td>
                                                <div className="pagebreak-footer"></div>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>


                        </div>
                        {/* <Gap height={10} /> */}
                        <div className="reportFooter">
                            <FooterReport date={dateTime} />
                        </div>
                        {/* <div class="pagebreak"> </div> */}
                    </div>
                </>
            )}

            {placeIps.length > 0 && (
                <>
                    {/* page 4 */}
                    <div className="report-page">
                        <div className="cardLine">
                            <div className="pnl-header">
                                <div className="card-page">
                                    <span style={{
                                        fontSize: '26px',
                                        color: '#FFF',
                                        fontWeight: 500,
                                        fontFamily: 'lucida grande'
                                    }}>04</span>
                                </div>
                                <div className="pnl-date">
                                    Jadwal Asesmen {detail.tglUjian}
                                </div>
                            </div>
                            <div className="header-first-page" style={{ padding: '0px' }}>
                                <div className="text-header" style={{ padding: '0px' }}>
                                    <div className="title-header2" style={{ color: '#015E56' }}>Hasil Program Peminatan Sekolah</div>
                                    <div className="label-sub-tit">
                                        <span className="sub-title-header" style={{ color: '#FFF' }}>Program Peminatan</span>
                                    </div>
                                </div>
                                <div className="image-header">
                                    <div className="logo-edu">
                                        <img src="https://eduprime.co.id/static/images/LOGO_EDUPRIME_2.png" width={"100%"} />
                                    </div>
                                    <div className="logo-an">
                                        <img src="/assets/image/LOGO_PEMINATAN_1.png" width={"100%"} />
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: '100%', display: 'flex', gap: '20px', marginTop: '5%' }}>
                                <div style={{ width: '6%' }}>
                                    <img src="/assets/image/la_atom.svg" width={"60px"} />
                                </div>
                                <div style={{ width: '94%' }}>
                                    <span style={{ fontSize: '28px', fontWeight: '700', color: '#212121' }}>Placement IPS</span>
                                    <div style={{ display: 'flex', gap: '20px' }}>
                                        <div style={{ display: 'flex', gap: '20px' }}>
                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <img src="/assets/image/mdi_check1_red.svg" width={"20px"} />
                                                <span style={{ fontSize: '18px', fontWeight: '400', color: '#6C757D' }}>Dibawah Rata-Rata</span>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', gap: '20px' }}>
                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <img src="/assets/image/mdi_doubleCheck_blue.svg" width={"20px"} />
                                                <span style={{ fontSize: '18px', fontWeight: '400', color: '#6C757D' }}>Rata-Rata</span>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', gap: '20px' }}>
                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <img src="/assets/image/verified_light_green.svg" width={"20px"} />
                                                <span style={{ fontSize: '18px', fontWeight: '400', color: '#6C757D' }}>Diatas Rata-Rata</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ marginTop: '3%' }}>
                                <table width={"100%"}>
                                    <thead
                                        style={{
                                            backgroundColor: "#BEF264",
                                            color: "#015E56",
                                            textAlign: "center",
                                        }}
                                    >
                                        <tr>
                                            <td rowSpan={2} width={"5%"}>
                                                No
                                            </td>
                                            <td rowSpan={2} width={"25%"}>
                                                Nama Siswa
                                            </td>
                                            <td colSpan={8} width={"25%"}>
                                                Mata Pelajaran
                                            </td>
                                            <td rowSpan={2} width={"10%"}>
                                                Rekomendasi
                                            </td>
                                            <td rowSpan={2} width={"10%"}>
                                                Placement
                                            </td>
                                            <td rowSpan={2} width={"10%"}>
                                                Learning Style
                                            </td>
                                            <td rowSpan={2} width={"5%"}>
                                                AQ
                                            </td>
                                            <td rowSpan={2} width={"5%"}>
                                                EQ
                                            </td>
                                            <td rowSpan={2} width={"5%"}>
                                                AM
                                            </td>
                                        </tr>
                                        <tr style={{ fontWeight: 100 }}>
                                            {listMapel.map((dataMapel, i) => {
                                                return <td key={i}>{dataMapel.namaMapelSingkatan}</td>;
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody
                                        style={{
                                            color: "#6C757D",
                                            textAlign: "center",
                                        }}
                                    >
                                        {placeIps.length > 0 &&
                                            placeIps.map((sk, i) => (
                                                <tr
                                                    style={{
                                                        borderBottom: "1px solid #E9ECEF",
                                                    }}
                                                >
                                                    <td>{i + 1}</td>
                                                    <td
                                                        style={{
                                                            textAlign: "left",
                                                        }}
                                                    >
                                                        {sk.namaSiswa}
                                                    </td>
                                                    {renderSkorMapelSiswa(listMapel, sk)}
                                                    <td>{sk.result}</td>
                                                    <td>{sk.placement}</td>
                                                    <td>{sk.resultLs}</td>
                                                    <td>{sk.resultAq != null ? <img src={"/assets/image/" + sk.resultAq + ".svg"} width={"45%"} /> : "-"}</td>
                                                    <td>{sk.resultEq != null ? <img src={"/assets/image/" + sk.resultEq + ".svg"} width={"45%"} /> : "-"}</td>
                                                    <td>{sk.resultAm != null ? <img src={"/assets/image/" + sk.resultAm + ".svg"} width={"45%"} /> : "-"}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td>
                                                <div className="pagebreak-footer"></div>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                        <div className="reportFooter">
                            <FooterReport date={dateTime} />
                        </div>
                        {/* <div class="pagebreak"> </div> */}
                    </div>
                </>
            )}

            {placeBhs.length > 0 && (
                <>
                    {/* page 5 */}
                    <div className="report-page">
                        <div className="cardLine">
                            <div className="pnl-header">
                                <div className="card-page">
                                    <span style={{
                                        fontSize: '26px',
                                        color: '#FFF',
                                        fontWeight: 500,
                                        fontFamily: 'lucida grande'
                                    }}>05</span>
                                </div>
                                <div className="pnl-date">
                                    Jadwal Asesmen {detail.tglUjian}
                                </div>
                            </div>
                            <div className="header-first-page" style={{ padding: '0px' }}>
                                <div className="text-header" style={{ padding: '0px' }}>
                                    <div className="title-header2" style={{ color: '#015E56' }}>Hasil Program Peminatan Sekolah</div>
                                    <div className="label-sub-tit">
                                        <span className="sub-title-header" style={{ color: '#FFF' }}>Program Peminatan</span>
                                    </div>
                                </div>
                                <div className="image-header">
                                    <div className="logo-edu">
                                        <img src="https://eduprime.co.id/static/images/LOGO_EDUPRIME_2.png" width={"100%"} />
                                    </div>
                                    <div className="logo-an">
                                        <img src="/assets/image/LOGO_PEMINATAN_1.png" width={"100%"} />
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: '100%', display: 'flex', gap: '20px', marginTop: '5%' }}>
                                <div style={{ width: '6%' }}>
                                    <img src="/assets/image/la_atom.svg" width={"60px"} />
                                </div>
                                <div style={{ width: '94%' }}>
                                    <span style={{ fontSize: '28px', fontWeight: '700', color: '#212121' }}>Placement Bahasa</span>
                                    <div style={{ display: 'flex', gap: '20px' }}>
                                        <div style={{ display: 'flex', gap: '20px' }}>
                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <img src="/assets/image/mdi_check1_red.svg" width={"20px"} />
                                                <span style={{ fontSize: '18px', fontWeight: '400', color: '#6C757D' }}>Dibawah Rata-Rata</span>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', gap: '20px' }}>
                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <img src="/assets/image/mdi_doubleCheck_blue.svg" width={"20px"} />
                                                <span style={{ fontSize: '18px', fontWeight: '400', color: '#6C757D' }}>Rata-Rata</span>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', gap: '20px' }}>
                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <img src="/assets/image/verified_light_green.svg" width={"20px"} />
                                                <span style={{ fontSize: '18px', fontWeight: '400', color: '#6C757D' }}>Diatas Rata-Rata</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ marginTop: '3%' }}>
                                <table width={"100%"}>
                                    <thead
                                        style={{
                                            backgroundColor: "#BEF264",
                                            color: "#015E56",
                                            textAlign: "center",
                                        }}
                                    >
                                        <tr>
                                            <td rowSpan={2} width={"5%"}>
                                                No
                                            </td>
                                            <td rowSpan={2} width={"25%"}>
                                                Nama Siswa
                                            </td>
                                            <td colSpan={8} width={"25%"}>
                                                Mata Pelajaran
                                            </td>
                                            <td rowSpan={2} width={"10%"}>
                                                Rekomendasi
                                            </td>
                                            <td rowSpan={2} width={"10%"}>
                                                Placement
                                            </td>
                                            <td rowSpan={2} width={"10%"}>
                                                Learning Style
                                            </td>
                                            <td rowSpan={2} width={"5%"}>
                                                AQ
                                            </td>
                                            <td rowSpan={2} width={"5%"}>
                                                EQ
                                            </td>
                                            <td rowSpan={2} width={"5%"}>
                                                AM
                                            </td>
                                        </tr>
                                        <tr style={{ fontWeight: 100 }}>
                                            {listMapel.map((dataMapel, i) => {
                                                return <td key={i}>{dataMapel.namaMapelSingkatan}</td>;
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody
                                        style={{
                                            color: "#6C757D",
                                            textAlign: "center",
                                        }}
                                    >
                                        {placeBhs.length > 0 &&
                                            placeBhs.map((sk, i) => (
                                                <tr
                                                    style={{
                                                        borderBottom: "1px solid #E9ECEF",
                                                    }}
                                                >
                                                    <td>{i + 1}</td>
                                                    <td
                                                        style={{
                                                            textAlign: "left",
                                                        }}
                                                    >
                                                        {sk.namaSiswa}
                                                    </td>
                                                    {renderSkorMapelSiswa(listMapel, sk)}
                                                    <td>{sk.result}</td>
                                                    <td>{sk.placement}</td>
                                                    <td>{sk.resultLs}</td>
                                                    <td>{sk.resultAq != null ? <img src={"/assets/image/" + sk.resultAq + ".svg"} width={"45%"} /> : "-"}</td>
                                                    <td>{sk.resultEq != null ? <img src={"/assets/image/" + sk.resultEq + ".svg"} width={"45%"} /> : "-"}</td>
                                                    <td>{sk.resultAm != null ? <img src={"/assets/image/" + sk.resultAm + ".svg"} width={"45%"} /> : "-"}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td>
                                                <div className="pagebreak-footer"></div>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                        <div className="reportFooter">
                            <FooterReport date={dateTime} />
                        </div>
                        {/* <div class="pagebreak"> </div> */}
                    </div>
                </>
            )}

            {placeAgama.length > 0 && (
                <>
                    {/* page 6 */}
                    <div className="report-page">
                        <div className="cardLine">
                            <div className="pnl-header">
                                <div className="card-page">
                                    <span style={{
                                        fontSize: '26px',
                                        color: '#FFF',
                                        fontWeight: 500,
                                        fontFamily: 'lucida grande'
                                    }}>06</span>
                                </div>
                                <div className="pnl-date">
                                    Jadwal Asesmen {detail.tglUjian}
                                </div>
                            </div>
                            <div className="header-first-page" style={{ padding: '0px' }}>
                                <div className="text-header" style={{ padding: '0px' }}>
                                    <div className="title-header2" style={{ color: '#015E56' }}>Hasil Program Peminatan Sekolah</div>
                                    <div className="label-sub-tit">
                                        <span className="sub-title-header" style={{ color: '#FFF' }}>Program Peminatan</span>
                                    </div>
                                </div>
                                <div className="image-header">
                                    <div className="logo-edu">
                                        <img src="https://eduprime.co.id/static/images/LOGO_EDUPRIME_2.png" width={"100%"} />
                                    </div>
                                    <div className="logo-an">
                                        <img src="/assets/image/LOGO_PEMINATAN_1.png" width={"100%"} />
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: '100%', display: 'flex', gap: '20px', marginTop: '5%' }}>
                                <div style={{ width: '6%' }}>
                                    <img src="/assets/image/la_atom.svg" width={"60px"} />
                                </div>
                                <div style={{ width: '94%' }}>
                                    <span style={{ fontSize: '28px', fontWeight: '700', color: '#212121' }}>Placement Agama</span>
                                    <div style={{ display: 'flex', gap: '20px' }}>
                                        <div style={{ display: 'flex', gap: '20px' }}>
                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <img src="/assets/image/mdi_check1_red.svg" width={"20px"} />
                                                <span style={{ fontSize: '18px', fontWeight: '400', color: '#6C757D' }}>Dibawah Rata-Rata</span>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', gap: '20px' }}>
                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <img src="/assets/image/mdi_doubleCheck_blue.svg" width={"20px"} />
                                                <span style={{ fontSize: '18px', fontWeight: '400', color: '#6C757D' }}>Rata-Rata</span>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', gap: '20px' }}>
                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <img src="/assets/image/verified_light_green.svg" width={"20px"} />
                                                <span style={{ fontSize: '18px', fontWeight: '400', color: '#6C757D' }}>Diatas Rata-Rata</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ marginTop: '3%' }}>
                                <table width={"100%"}>
                                    <thead
                                        style={{
                                            backgroundColor: "#BEF264",
                                            color: "#015E56",
                                            textAlign: "center",
                                        }}
                                    >
                                        <tr>
                                            <td rowSpan={2} width={"5%"}>
                                                No
                                            </td>
                                            <td rowSpan={2} width={"25%"}>
                                                Nama Siswa
                                            </td>
                                            <td colSpan={8} width={"25%"}>
                                                Mata Pelajaran
                                            </td>
                                            <td rowSpan={2} width={"10%"}>
                                                Rekomendasi
                                            </td>
                                            <td rowSpan={2} width={"10%"}>
                                                Placement
                                            </td>
                                            <td rowSpan={2} width={"10%"}>
                                                Learning Style
                                            </td>
                                            <td rowSpan={2} width={"5%"}>
                                                AQ
                                            </td>
                                            <td rowSpan={2} width={"5%"}>
                                                EQ
                                            </td>
                                            <td rowSpan={2} width={"5%"}>
                                                AM
                                            </td>
                                        </tr>
                                        <tr style={{ fontWeight: 100 }}>
                                            {listMapel.map((dataMapel, i) => {
                                                return <td key={i}>{dataMapel.namaMapelSingkatan}</td>;
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody
                                        style={{
                                            color: "#6C757D",
                                            textAlign: "center",
                                        }}
                                    >
                                        {placeAgama.length > 0 &&
                                            placeAgama.map((sk, i) => (
                                                <tr
                                                    style={{
                                                        borderBottom: "1px solid #E9ECEF",
                                                    }}
                                                >
                                                    <td>{i + 1}</td>
                                                    <td
                                                        style={{
                                                            textAlign: "left",
                                                        }}
                                                    >
                                                        {sk.namaSiswa}
                                                    </td>
                                                    {renderSkorMapelSiswa(listMapel, sk)}
                                                    <td>{sk.result}</td>
                                                    <td>{sk.placement}</td>
                                                    <td>{sk.resultLs}</td>
                                                    <td>{sk.resultAq != null ? <img src={"/assets/image/" + sk.resultAq + ".svg"} width={"45%"} /> : "-"}</td>
                                                    <td>{sk.resultEq != null ? <img src={"/assets/image/" + sk.resultEq + ".svg"} width={"45%"} /> : "-"}</td>
                                                    <td>{sk.resultAm != null ? <img src={"/assets/image/" + sk.resultAm + ".svg"} width={"45%"} /> : "-"}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td>
                                                <div className="pagebreak-footer"></div>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                        {/* <Gap height={10} /> */}
                        <div className="reportFooter">
                            <FooterReport date={dateTime} />
                        </div>
                        {/* <div class="pagebreak"> </div> */}
                    </div>
                </>
            )}

            {blmSelesai.length > 0 && (
                <>
                    <div className="report-page">
                        <div className="cardLine">
                            <div className="pnl-header">
                                <div className="card-page">
                                    <span style={{
                                        fontSize: '26px',
                                        color: '#FFF',
                                        fontWeight: 500,
                                        fontFamily: 'lucida grande'
                                    }}>06</span>
                                </div>
                                <div className="pnl-date">
                                    Jadwal Asesmen {detail.tglUjian}
                                </div>
                            </div>
                            <div className="header-first-page" style={{ padding: '0px' }}>
                                <div className="text-header" style={{ padding: '0px' }}>
                                    <div className="title-header2" style={{ color: '#015E56' }}>Hasil Program Peminatan Sekolah</div>
                                    <div className="label-sub-tit">
                                        <span className="sub-title-header" style={{ color: '#FFF' }}>Program Peminatan</span>
                                    </div>
                                </div>
                                <div className="image-header">
                                    <div className="logo-edu">
                                        <img src="https://eduprime.co.id/static/images/LOGO_EDUPRIME_2.png" width={"100%"} />
                                    </div>
                                    <div className="logo-an">
                                        <img src="/assets/image/LOGO_PEMINATAN_1.png" width={"100%"} />
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: '100%', display: 'flex', gap: '20px', marginTop: '5%' }}>
                                <div style={{ width: '6%' }}>
                                    <img src="/assets/image/la_atom.svg" width={"60px"} />
                                </div>
                                <div style={{ width: '94%' }}>
                                    <span style={{ fontSize: '28px', fontWeight: '700', color: '#212121' }}>Belum Selesai</span>
                                    <div style={{ display: 'flex', gap: '20px' }}>
                                        <div style={{ display: 'flex', gap: '20px' }}>
                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <img src="/assets/image/mdi_check1_red.svg" width={"20px"} />
                                                <span style={{ fontSize: '18px', fontWeight: '400', color: '#6C757D' }}>Dibawah Rata-Rata</span>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', gap: '20px' }}>
                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <img src="/assets/image/mdi_doubleCheck_blue.svg" width={"20px"} />
                                                <span style={{ fontSize: '18px', fontWeight: '400', color: '#6C757D' }}>Rata-Rata</span>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', gap: '20px' }}>
                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                <img src="/assets/image/verified_light_green.svg" width={"20px"} />
                                                <span style={{ fontSize: '18px', fontWeight: '400', color: '#6C757D' }}>Diatas Rata-Rata</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ marginTop: '3%' }}>
                                <table width={"100%"}>
                                    <thead
                                        style={{
                                            backgroundColor: "#BEF264",
                                            color: "#015E56",
                                            textAlign: "center",
                                        }}
                                    >
                                        <tr>
                                            <td rowSpan={2} width={"5%"}>
                                                No
                                            </td>
                                            <td rowSpan={2} width={"25%"}>
                                                Nama Siswa
                                            </td>
                                            <td colSpan={8} width={"25%"}>
                                                Mata Pelajaran
                                            </td>
                                            <td rowSpan={2} width={"10%"}>
                                                Rekomendasi
                                            </td>
                                            <td rowSpan={2} width={"10%"}>
                                                Placement
                                            </td>
                                            <td rowSpan={2} width={"10%"}>
                                                Learning Style
                                            </td>
                                            <td rowSpan={2} width={"5%"}>
                                                AQ
                                            </td>
                                            <td rowSpan={2} width={"5%"}>
                                                EQ
                                            </td>
                                            <td rowSpan={2} width={"5%"}>
                                                AM
                                            </td>
                                        </tr>
                                        <tr style={{ fontWeight: 100 }}>
                                            {listMapel.map((dataMapel, i) => {
                                                return <td key={i}>{dataMapel.namaMapelSingkatan}</td>;
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody
                                        style={{
                                            color: "#6C757D",
                                            textAlign: "center",
                                        }}
                                    >
                                        {blmSelesai.length > 0 &&
                                            blmSelesai.map((sk, i) => (
                                                <tr
                                                    style={{
                                                        borderBottom: "1px solid #E9ECEF",
                                                    }}
                                                >
                                                    <td>{i + 1}</td>
                                                    <td
                                                        style={{
                                                            textAlign: "left",
                                                        }}
                                                    >
                                                        {sk.namaSiswa}
                                                    </td>
                                                    {renderSkorMapelSiswa(listMapel, sk)}
                                                    <td>{sk.result}</td>
                                                    <td>{sk.placement}</td>
                                                    <td>{sk.resultLs}</td>
                                                    <td>{sk.resultAq != null ? <img src={"/assets/image/" + sk.resultAq + ".svg"} width={"45%"} /> : "-"}</td>
                                                    <td>{sk.resultEq != null ? <img src={"/assets/image/" + sk.resultEq + ".svg"} width={"45%"} /> : "-"}</td>
                                                    <td>{sk.resultAm != null ? <img src={"/assets/image/" + sk.resultAm + ".svg"} width={"45%"} /> : "-"}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td>
                                                <div className="pagebreak-footer"></div>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                        {/* <Gap height={10} /> */}
                        <div className="reportFooter">
                            <FooterReport date={dateTime} />
                        </div>
                        {/* <div class="pagebreak"> </div> */}
                    </div>
                </>
            )}
            <div style={styles.fixedButton}>
                <button className="buttonPrint" onClick={() => window.print()}>
                    <img src="/assets/image/print.png" width={22} style={{ marginRight: 5 }} />
                    Print Report
                </button>
            </div>
        </div>
    );
};

export default ReportPeminatan;

const styles = {
    fixedButton: {
        position: "fixed",
        bottom: "20px",
        right: "0px",
        height: "auto",
        padding: "15px",
        zIndex: 99,
        // -webkit-transform: translate3d(0, 0, 0),
        transition: "all 0.25s ease",
        textAlign: "center",
    },
};
